import React from "react";

import { faCirclePlus } from "@performyard/fontawesome/pro-solid-svg-icons";
import { Text } from "@performyard/py-components";

import { FormQuestionPreviewCard } from "./FormQuestionPreviewCard";
import { GeneratedContentContainer } from "./GeneratedContentContainer";

import type { FormQuestionSuggestionState, FormQuestionSuggestionWithId } from "../types";

type FormQuestionSuggestionsContainerProps = {
	suggestionStates: FormQuestionSuggestionState[];
	onAddQuestion: (suggestion: FormQuestionSuggestionWithId) => void;
	onDeleteQuestion: (suggestionId: string) => void;
};

export const FormQuestionSuggestionsContainer: React.FC<FormQuestionSuggestionsContainerProps> = ({
	suggestionStates,
	onAddQuestion,
	onDeleteQuestion,
}) => {
	const visible = suggestionStates.filter((fs) => fs.status !== "deleted");
	const allDeleted = visible.length === 0;
	const pending = visible.filter((fs) => fs.status === "pending");
	const headerAction =
		pending.length > 1
			? {
					label: "Add All Questions",
					iconLeft: faCirclePlus,
					color: "primary" as const,
					onClick: () => {
						pending.forEach((fs) => onAddQuestion(fs.suggestion));
					},
				}
			: undefined;

	return (
		<GeneratedContentContainer title="Suggested Questions" headerAction={headerAction}>
			{allDeleted ? (
				<Text size="paragraph-3" color="neutral-7">
					All suggested questions have been removed.
				</Text>
			) : (
				visible.map((fs) => (
					<FormQuestionPreviewCard
						key={fs.suggestion.id}
						suggestion={fs.suggestion}
						status={fs.status}
						onAdd={() => onAddQuestion(fs.suggestion)}
						onDelete={() => onDeleteQuestion(fs.suggestion.id)}
					/>
				))
			)}
		</GeneratedContentContainer>
	);
};
